export default [
    {
        name: "RecurringTasks",
        path: '/recurring-tasks',
        component: () => import('../components/includes/TaskCenterNew/RecurringTasks.vue'),
        meta: {
            requiresAuth: true,
            hasAccess: ['admin'],
            layout: 'master',
            re_fetch: true
        }
    }
]